module.exports = __webpack_public_path__ + "img/pbjjjfa.9a8a134c.png";